"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrashMenuItem = exports.getResolveMenuItem = exports.getReportMenuItem = exports.getQuoteMenuItem = exports.getMoveToExistingTopicMenuItem = exports.getMergeIdeaMenuItem = exports.getMarkAsSpamMenuItem = exports.getHighlightReplyMenuItem = exports.getEditMenuItem = exports.getDuplicateTopicMenuItem = exports.getCopyLinkMenuItem = exports.getConvertToQuestionMenuItem = exports.getConvertToProductUpdateMenuItem = exports.getConvertToIdeaMenuItem = exports.getConvertToConversationMenuItem = exports.getConvertToArticleMenuItem = exports.getCloseTopicMenuItem = exports.getChangeAuthorMenuItem = exports.getBestAnswerMenuItem = exports.getApproveMenuItem = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("../../utils");

var getBestAnswerMenuItem = function getBestAnswerMenuItem(isBestAnswer, onMarkBestAnswer) {
  return {
    title: isBestAnswer ? 'frontend_moderation.unmark_as_best_answer' : 'frontend_moderation.mark_as_best_answer',
    onClick: function onClick(e) {
      e.preventDefault();
      onMarkBestAnswer(e);
    },
    'data-element-name': 'mark-best-answer',
    'data-qa': 'menu-best-answer'
  };
};

exports.getBestAnswerMenuItem = getBestAnswerMenuItem;

var getQuoteMenuItem = function getQuoteMenuItem(onQuote) {
  return {
    title: 'Quote',
    onClick: function onClick(e) {
      e.preventDefault();
      onQuote(e);
    },
    'data-element-name': 'quote-post',
    'data-qa': 'menu-quote'
  };
};

exports.getQuoteMenuItem = getQuoteMenuItem;

var getEditMenuItem = function getEditMenuItem(onEdit) {
  return {
    title: 'Edit',
    onClick: function onClick(e) {
      e.preventDefault();
      onEdit(e);
    },
    'data-element-name': 'edit-post',
    'data-qa': 'menu-edit'
  };
};

exports.getEditMenuItem = getEditMenuItem;

var getCopyLinkMenuItem = function getCopyLinkMenuItem(postId, onShowAlert) {
  return {
    title: 'frontend_moderation.copy_link',
    'data-qa': 'menu-copy-link',
    onClick: function () {
      var _onClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var permalink;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _context.prev = 1;
                permalink = (0, _utils.getPermalink)(Number(postId));
                _context.next = 5;
                return navigator.clipboard.writeText(permalink);

              case 5:
                onShowAlert('success', 'frontend_moderation.link_copied_to_clipboard');
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                onShowAlert('error', 'frontend_moderation.failed_to_copy_link_to_clipboard');

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      function onClick(_x) {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }()
  };
};

exports.getCopyLinkMenuItem = getCopyLinkMenuItem;

var getReportMenuItem = function getReportMenuItem(onToggleReportModal) {
  return {
    title: 'frontend_moderation.report',
    'data-qa': 'menu-report',
    onClick: function onClick(e) {
      return (0, _utils.onReport)(e, onToggleReportModal);
    }
  };
};

exports.getReportMenuItem = getReportMenuItem;

var getCloseTopicMenuItem = function getCloseTopicMenuItem(isClosed, onCloseToggle) {
  return {
    title: isClosed ? 'frontend_moderation.reopen_topic_for_replies' : 'frontend_moderation.close_topic_for_replies',
    type: 'normal',
    'data-qa': 'menu-close-topic',
    onClick: onCloseToggle
  };
};

exports.getCloseTopicMenuItem = getCloseTopicMenuItem;

var getHighlightReplyMenuItem = function getHighlightReplyMenuItem(isHighlighted, onToggleHighlight) {
  return {
    title: isHighlighted ? 'frontend_moderation.unmark_as_highlight' : 'frontend_moderation.mark_as_highlight',
    type: 'normal',
    'data-qa': 'menu-highlight',
    onClick: onToggleHighlight
  };
};

exports.getHighlightReplyMenuItem = getHighlightReplyMenuItem;

var getMarkAsSpamMenuItem = function getMarkAsSpamMenuItem(onToggleSpamModal) {
  var isSpam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    title: isSpam ? 'frontend_moderation.unmark_as_spam' : 'frontend_moderation.mark_as_spam',
    type: isSpam ? 'normal' : 'alert',
    'data-qa': 'menu-spam',
    onClick: function onClick(e) {
      e.preventDefault();
      onToggleSpamModal(true);
    }
  };
};

exports.getMarkAsSpamMenuItem = getMarkAsSpamMenuItem;

var getTrashMenuItem = function getTrashMenuItem(updateTrashStatus) {
  var isTrashed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    title: isTrashed ? 'frontend_moderation.restore' : 'frontend_moderation.trash',
    type: isTrashed ? 'normal' : 'alert',
    'data-qa': 'menu-trash',
    onClick: function onClick(e) {
      e.preventDefault();
      updateTrashStatus(true);
    }
  };
};

exports.getTrashMenuItem = getTrashMenuItem;

var getResolveMenuItem = function getResolveMenuItem(onToggleResolveModal) {
  return {
    title: 'Resolve',
    type: 'normal',
    'data-qa': 'menu-resolve',
    onClick: function onClick(e) {
      e.preventDefault();
      onToggleResolveModal(true);
    }
  };
};

exports.getResolveMenuItem = getResolveMenuItem;

var getApproveMenuItem = function getApproveMenuItem(onApprove) {
  return {
    title: 'Approve',
    type: 'normal',
    'data-qa': 'menu-approve',
    onClick: function () {
      var _onClick2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _context2.next = 3;
                return onApprove(e);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onClick(_x2) {
        return _onClick2.apply(this, arguments);
      }

      return onClick;
    }()
  };
};

exports.getApproveMenuItem = getApproveMenuItem;

var getChangeAuthorMenuItem = function getChangeAuthorMenuItem(onToggleChangeAuthorModal) {
  return {
    title: 'Change author',
    type: 'normal',
    'data-qa': 'menu-change-author',
    onClick: function onClick(e) {
      e.preventDefault();
      onToggleChangeAuthorModal(true);
    }
  };
}; // Topic action menu items


exports.getChangeAuthorMenuItem = getChangeAuthorMenuItem;

var getMoveToExistingTopicMenuItem = function getMoveToExistingTopicMenuItem(onMove) {
  return {
    title: 'Move to existing topic',
    type: 'normal',
    'data-qa': 'menu-move-to-existing-topic',
    onClick: function onClick(e) {
      e.preventDefault();
      onMove();
    }
  };
};

exports.getMoveToExistingTopicMenuItem = getMoveToExistingTopicMenuItem;

var getDuplicateTopicMenuItem = function getDuplicateTopicMenuItem(onDuplicate) {
  return {
    title: 'Duplicate topic',
    type: 'normal',
    'data-qa': 'menu-duplicate-topic',
    onClick: function onClick(e) {
      e.preventDefault();
      onDuplicate();
    }
  };
};

exports.getDuplicateTopicMenuItem = getDuplicateTopicMenuItem;

var getMergeIdeaMenuItem = function getMergeIdeaMenuItem(onMerge) {
  return {
    title: 'Merge idea',
    type: 'normal',
    'data-qa': 'menu-merge-idea',
    onClick: function onClick(e) {
      e.preventDefault();
      onMerge();
    }
  };
}; // Convert menu items


exports.getMergeIdeaMenuItem = getMergeIdeaMenuItem;

var getConvertToQuestionMenuItem = function getConvertToQuestionMenuItem(onConvert) {
  return {
    title: 'Convert to question',
    type: 'normal',
    'data-qa': 'menu-convert-to-question',
    onClick: function onClick(e) {
      e.preventDefault();
      onConvert();
    }
  };
};

exports.getConvertToQuestionMenuItem = getConvertToQuestionMenuItem;

var getConvertToConversationMenuItem = function getConvertToConversationMenuItem(onConvert) {
  var isBugContentTypeEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    title: isBugContentTypeEnabled ? 'Convert to bug' : 'Convert to conversation',
    type: 'normal',
    'data-qa': 'menu-convert-to-conversation',
    onClick: function onClick(e) {
      e.preventDefault();
      onConvert();
    }
  };
};

exports.getConvertToConversationMenuItem = getConvertToConversationMenuItem;

var getConvertToArticleMenuItem = function getConvertToArticleMenuItem(onConvert) {
  return {
    title: 'Convert to article',
    type: 'normal',
    'data-qa': 'menu-convert-to-article',
    onClick: function onClick(e) {
      e.preventDefault();
      onConvert();
    }
  };
};

exports.getConvertToArticleMenuItem = getConvertToArticleMenuItem;

var getConvertToIdeaMenuItem = function getConvertToIdeaMenuItem(onConvert) {
  return {
    title: 'Convert to idea',
    type: 'normal',
    'data-qa': 'menu-convert-to-idea',
    onClick: function onClick(e) {
      e.preventDefault();
      onConvert();
    }
  };
};

exports.getConvertToIdeaMenuItem = getConvertToIdeaMenuItem;

var getConvertToProductUpdateMenuItem = function getConvertToProductUpdateMenuItem(onConvert) {
  return {
    title: 'Convert to product update',
    type: 'normal',
    'data-qa': 'menu-convert-to-product-update',
    onClick: function onClick(e) {
      e.preventDefault();
      onConvert();
    }
  };
};

exports.getConvertToProductUpdateMenuItem = getConvertToProductUpdateMenuItem;